import React from 'react'
import DynamicForm from '../../components/DynamicForm/DynamicForm';
import {getStoredData} from "../../JsonFiles/fetchData";

const AdminDevFeedback = () => {
  const fields = getStoredData()?.["11"]?.AdminFeedBack?? {};
  const apiUrl = 'https://shahbad-enterprises-backend.vercel.app/feedback'; // API URL for fetching/editing product
  const successRedirect = '/admin'; // Where to redirect after a successful update

  return (
    <div>
      <DynamicForm fields={fields} apiUrl={apiUrl} successRedirect={successRedirect} />
    </div>
  )
}

export default AdminDevFeedback